// 🔁 "I couldn't find this one — I sent this product" (user 2026-10-23). The worker picks the product he really put in
// the parcel; the stock is then deducted from THAT product (Daily Shipments) and the ordered one is flagged for a recount.
import { FC, useEffect, useRef, useState } from "react";
import { dispatch } from "../../dispatch/dispatch";
import { actions } from "../../dispatch";

interface Group { groupId: string; name: string; image: string | null; stock: number | null; location: string }

export const SwapPicker: FC<{
    platform?: "jumia" | "marjan";
    storeId: string; orderId: string; orderNumber: string; sku: string; qty: number;
    orderedName: string; orderedImage?: string;
    onClose: () => void; onDone: () => void;
}> = ({ platform = "jumia", storeId, orderId, orderNumber, sku, qty, orderedName, orderedImage, onClose, onDone }) => {
    const [q, setQ] = useState("");
    const [list, setList] = useState<Group[]>([]);
    const [pick, setPick] = useState<Group | null>(null);
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState<string | null>(null);
    const input = useRef<HTMLInputElement>(null);
    useEffect(() => { input.current?.focus(); }, []);
    useEffect(() => {
        if (q.trim().length < 2) { setList([]); return; }
        const t = setTimeout(async () => { const r: any = await dispatch(actions.searchGroups, {}, { q }); setList(r?.groups || []); }, 300);
        return () => clearTimeout(t);
    }, [q]);
    const confirm = async () => {
        if (!pick) return;
        setBusy(true); setErr(null);
        const r: any = await dispatch(actions.substitute, { platform, storeId, orderId, orderNumber, sku, qty, toGroupId: pick.groupId });
        setBusy(false);
        if (!r || r.error) return setErr(r?.error?.message || "خطأ");
        onDone();
    };
    return (
        <div dir="rtl" onClick={onClose} className="fixed inset-0 z-50 flex items-end justify-center bg-black/50 sm:items-center">
            <div onClick={(e) => e.stopPropagation()} className="max-h-[92vh] w-full max-w-xl overflow-auto rounded-t-3xl bg-white p-4 sm:rounded-3xl">
                <p className="text-2xl font-black text-slate-900">🔁 بدّلت المنتج</p>
                <div className="mt-2 flex items-center gap-3 rounded-2xl bg-red-50 p-3">
                    {orderedImage ? <img src={orderedImage} alt="" className="h-16 w-16 rounded-xl bg-white object-contain" /> : null}
                    <div className="min-w-0"><p className="text-sm font-bold text-red-700">ما لقيتش هاد المنتج:</p><p className="ltr truncate text-start text-base font-black text-slate-800">{orderedName}</p><p className="ltr text-start font-mono text-xs text-slate-500">{sku} · ×{qty}</p></div>
                </div>
                <p className="mt-3 text-lg font-black text-slate-800">شنو المنتج اللي صيفطتي بلاصتو؟</p>
                <input ref={input} value={q} onChange={(e) => { setQ(e.target.value); setPick(null); }} placeholder="كتب السمية ولا سكاني الكود…"
                    className="mt-2 w-full rounded-2xl border-2 border-slate-300 px-4 py-3 text-xl font-bold" />
                <div className="mt-2 space-y-2">
                    {list.map((g) => (
                        <button key={g.groupId} onClick={() => setPick(g)}
                            className={`flex w-full items-center gap-3 rounded-2xl border-2 p-2 text-start ${pick?.groupId === g.groupId ? "border-emerald-500 bg-emerald-50" : "border-slate-200 bg-white"}`}>
                            {g.image ? <img src={g.image} alt="" className="h-16 w-16 shrink-0 rounded-xl bg-white object-contain" /> : <div className="h-16 w-16 shrink-0 rounded-xl bg-slate-100" />}
                            <div className="min-w-0 flex-1">
                                <p className="ltr truncate text-start text-lg font-black text-slate-900">{g.name}</p>
                                <p className="text-sm font-bold text-slate-500">{g.location ? `📍 ${g.location} · ` : ""}المخزون: {g.stock ?? "؟"}</p>
                            </div>
                            {pick?.groupId === g.groupId && <span className="text-3xl">✅</span>}
                        </button>
                    ))}
                    {q.trim().length >= 2 && !list.length && <p className="p-3 text-center text-base font-bold text-slate-400">ما كاين حتى منتج بهاد السمية</p>}
                </div>
                {err && <p className="mt-2 rounded-xl bg-red-100 p-2 text-base font-bold text-red-700">⚠️ {err}</p>}
                <div className="mt-4 grid grid-cols-3 gap-2">
                    <button disabled={!pick || busy} onClick={confirm} className="col-span-2 rounded-2xl bg-emerald-600 px-4 py-4 text-2xl font-black text-white disabled:opacity-40">{busy ? "…" : "✅ تأكيد"}</button>
                    <button onClick={onClose} className="rounded-2xl bg-slate-200 px-4 py-4 text-xl font-black text-slate-700">إلغاء</button>
                </div>
                <p className="mt-2 text-center text-xs font-bold text-slate-400">المخزون غادي ينقص من المنتج اللي صيفطتي · والمسؤول غادي يتعلم باش يحسب المنتج اللي ما لقيتيش</p>
            </div>
        </div>
    );
};

export const undoSwap = async (args: { platform?: "jumia" | "marjan"; storeId: string; orderId: string; sku: string }) =>
    dispatch(actions.substituteRemove, { platform: "jumia", ...args });
